import { CaretDownIcon } from '@phosphor-icons/react'
import React, { useId, useRef, useState } from 'react'

import * as S from './accordion.styled'
import { AccordionProps } from './accordion.types'

export const Accordion = ({
  title,
  children,
  className = '',
  // NOTE: isOpen = undefined is intentionally, to control state.
  // NOTE: There is no point of passing both `isOpen` & `defaultOpen` props simultaneously,
  // except for the cases when `isOpen` conditionally becomes uncontrolled
  isOpen = undefined,
  defaultOpen = false,
  onToggle,
}: AccordionProps) => {
  const isControlled = isOpen != null
  const [open, setOpen] = useState(defaultOpen)
  const contentRef = useRef<HTMLDivElement>(null)

  const actualOpen = isControlled ? isOpen : open

  const handleToggleClick = () => {
    if (!isControlled) {
      setOpen((prev) => !prev)
      return
    }

    onToggle?.(!actualOpen)
  }

  const accordionId = useId()

  return (
    <S.AccordionContainer data-accordion-container className={className}>
      <S.AccordionButton
        data-accordion-button
        type="button"
        aria-expanded={actualOpen}
        aria-controls={accordionId}
        onClick={handleToggleClick}
      >
        {title}
        <S.AccordionIcon
          data-accordion-icon
          icon={CaretDownIcon}
          size="2rem"
          $isOpen={actualOpen}
        />
      </S.AccordionButton>
      <S.AccordionContent
        ref={contentRef}
        data-accordion-content
        id={accordionId}
        style={actualOpen ? { maxHeight: contentRef.current?.scrollHeight } : { maxHeight: 0 }}
        aria-hidden={!actualOpen}
      >
        <div data-accordion-children-wrapper>{children}</div>
      </S.AccordionContent>
    </S.AccordionContainer>
  )
}
